export default __webpack_public_path__ + "static/media/centro_berazategui.fa7859c5.jpg";